import { Icon } from "@material-ui/core";
import { css } from "@emotion/react";
import styled from "../../../../../config/emotion";
import Loader from "../../../Loader";

export const buttonCss = (buttonColor: string) => css`
  height: 34px !important;
  min-width: 34px !important;
  font-size: 14px;
  background-color: ${buttonColor};
  color: white !important;
  border-radius: 17px !important;
  border: none !important;
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  justify-content: center;
  display: inline-flex;
  align-items: center;
  transition: background-image 0.2s ease-in-out;

  &:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.2) 0 0);
    transition: background-image 0.2s ease-in-out;
  }
`;

export const circularBtnCss = css`
  border-radius: 50%;
`;

export const disabledBtnCss = css`
  color: rgba(0, 0, 0, 0.26) !important;
  box-shadow: none !important;
  background-color: rgba(0, 0, 0, 0.12) !important;
`;

export const extendedBtnCss = css`
  min-width: auto !important;
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0px 16px !important;
  text-transform: uppercase;
`;

export const IconContainer = styled.div`
  width: fit-content;
  height: fit-content;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FunctionButtonIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== "isLoading" && prop !== "iconSize",
})<{ isLoading: boolean; iconSize: number }>`
  ${
    ({ isLoading }) => isLoading && "visibility: hidden;" // chci skrýt visibility, ne display, aby se neresizenul container, když se zobrazí loader
  }
  font-size: ${({ iconSize }) => iconSize}px;
`;

export const FunctionButtonLoader = styled(Loader)`
  position: absolute;
  height: fit-content;
`;

export const ButtonLabel = styled.span`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const linkCss = css`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

// https://stackoverflow.com/questions/48930334/mui-next-tooltip-does-not-show-on-hover
export const buttonWrapperCss = css`
  cursor: pointer;
  pointer-events: auto;
`;
